import React from 'react';
import Carrier from '../../carrier';

const { ManageCarrier } = Carrier;

const CarriersView = ({ enterpriseLocation, callback }) => (
	<div className="settings-common-carriers-view">
		<ManageCarrier
			enterpriseLocation={enterpriseLocation}
			addCarrierCallback={callback}
		/>
	</div>
);

export default CarriersView;
